// NotFound.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const GeneralErrorPage: React.FC = () => {
  return (
    <div className="content">
      <div className="text-center mt-10">
        <h1 className="text-4xl font-bold"> Παρουσιάστηκε ένα σφάλμα</h1>
        <p className="text-lg mt-4">Προσπαθήστε ξανά σε λίγο.</p>
      </div>
    </div>
  );
};

export default GeneralErrorPage;